// How long an animation frame shows, within what the server accepts
// (DELAY_MS in Converters::PixelsToWindowsCursor).
export class FrameDelay {
  static readonly MIN_MS = 20
  static readonly MAX_MS = 2000
  static readonly STEP_MS = 10

  static clamp(ms: number) {
    const rounded = Math.round(ms / FrameDelay.STEP_MS) * FrameDelay.STEP_MS
    return Math.max(FrameDelay.MIN_MS, Math.min(FrameDelay.MAX_MS, rounded))
  }
}
